import React from 'react'

import {
    AllEvents,
    createEditionSelectItemEvent,
    Product,
    WebLink,
} from '@news-mono/web-common'
import {
    StyledEditionImage,
    StyledEditionItem,
    StyledItemDescription,
    StyledItemDetail,
} from './EditionItem.styled'
import { format } from 'date-fns'
import { EditionV4DTO } from '@west-australian-newspapers/publication-types'
import { StyledNightlyEditionListButtonContainer } from '../../SpecificEdition/NightlySpecificEdition.styled'
import { NightlyButton } from '../../../../buttons/NightlyButton/NightlyButton'

export type SpecialEditionItemProps = {
    edition: EditionV4DTO
    lazyloadImages?: boolean
    onEvent?: (event: AllEvents) => void
}

export const SpecialEditionItem = ({
    edition,
    lazyloadImages = false,
    onEvent,
}: SpecialEditionItemProps) => {
    const { title, teaser, publicationDate } = edition
    const link = edition.editionWebUrl
    const path = edition.primaryTopic ?? ''
    const imageURL = edition.mainImages?.[0]?.src

    const handleClick = () => {
        onEvent &&
            onEvent(
                createEditionSelectItemEvent({
                    edition,
                    collectionName: 'TheNightlyOn_EditionImage',
                    product: Product.TheNightly,
                    itemDetails: {
                        category: 'thenightly_on_home_page',
                        linkText: `${title} Image`,
                        linkUrl: link,
                        imageUrl: imageURL,
                    },
                }),
            )
    }

    return (
        <StyledEditionItem>
            {imageURL && (
                <WebLink to={link} onClick={handleClick}>
                    <StyledEditionImage
                        src={imageURL}
                        alt={title}
                        loading={lazyloadImages ? 'lazy' : undefined}
                    />
                </WebLink>
            )}

            <StyledItemDetail>
                <time dateTime={publicationDate}>
                    {format(new Date(publicationDate), 'd MMM yyyy')}
                </time>
                <StyledItemDescription>{teaser}</StyledItemDescription>
                <StyledNightlyEditionListButtonContainer>
                    <NightlyButton
                        variant={'default'}
                        text={'Read Now'}
                        action={{
                            type: 'link',
                            to: link,
                            onClick: () =>
                                onEvent &&
                                onEvent(
                                    createEditionSelectItemEvent({
                                        edition,
                                        collectionName:
                                            'TheNightlyOn_ReadNowButton',
                                        product: Product.TheNightly,
                                        itemDetails: {
                                            category: 'thenightly_on_home_page',
                                            linkText: 'Read Now',
                                            linkUrl: link,
                                            imageUrl: imageURL,
                                        },
                                    }),
                                ),
                        }}
                        color={'primary'}
                        fill={'filled'}
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                    />
                    <NightlyButton
                        variant={'default'}
                        text={'More Articles'}
                        action={{
                            type: 'link',
                            to: path,
                            onClick: () =>
                                onEvent &&
                                onEvent(
                                    createEditionSelectItemEvent({
                                        edition,
                                        collectionName:
                                            'TheNightlyOn_MoreArticlesButton',
                                        product: Product.TheNightly,
                                        itemDetails: {
                                            category: 'thenightly_on_home_page',
                                            linkText: 'More Articles',
                                            linkUrl: path,
                                            imageUrl: imageURL,
                                        },
                                    }),
                                ),
                        }}
                        color={'primary'}
                        fill={'outline'}
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                    />
                </StyledNightlyEditionListButtonContainer>
            </StyledItemDetail>
        </StyledEditionItem>
    )
}
